import { useTranslation } from 'react-i18next'
import {
  Activity,
  Settings,
  BarChart3,
  Bell,
  type LucideIcon,
  FlaskConical,
  FolderOpen,
  Forklift,
  Users,
  Map,
  MonitorPlay,
  Waypoints,
} from 'lucide-react'
import type { AppDefinition } from '@/config/apps'

const iconMap: Record<string, LucideIcon> = {
  activity: Activity,
  settings: Settings,
  'bar-chart': BarChart3,
  bell: Bell,
  'flask-conical': FlaskConical,
  'monitor-play': MonitorPlay,
  users: Users,
  map: Map,
  'folder-open': FolderOpen,
  waypoints: Waypoints,
  forklift: Forklift,
}

interface AppCardProps {
  app: AppDefinition
}

export default function AppCard({ app }: AppCardProps) {
  const { t } = useTranslation()
  const Icon = iconMap[app.icon] || Activity

  return (
    <a
      href={app.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group block p-6 bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-gray-300 transition-all"
    >
      <div
        className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
        style={{ backgroundColor: `${app.color}15` }}
      >
        <Icon className="w-6 h-6" style={{ color: app.color }} />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-primary-600 transition-colors">
        {t(`apps.${app.id}.name`)}
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {t(`apps.${app.id}.description`)}
      </p>
    </a>
  )
}
